export default __webpack_public_path__ + "static/media/360Advisor.2e2cdf7f.svg";